import { ButtonComponent } from "@syncfusion/ej2-react-buttons";
import {
  TabComponent,
  TabItemDirective,
  TabItemsDirective,
} from "@syncfusion/ej2-react-navigations";
import saveIcon from "../../../../icons/common/save.png";
import closeIcon from "../../../../icons/common/close.png";
import activeIcon from "../../../../icons/common/active.png";
import inactiveIcon from "../../../../icons/common/inactive.png";
import "./previewTab.scss";
import { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  messageManagemetnSettingsEndPoint,
  updatemessageManagementSettingsEndPoint,
} from "../../utils";
import axios from "axios";
import { setRowData } from "../../..//grid/gridReducer";
import {
  setMobileMsgData,
  setReclaimScanMsgData,
} from "../../settingsReducers";
import notify from "../../../../services/toasterService";
import { RootState } from "../../../../redux/store";
import PreviewReclaimScan from "../reclaimScan/reclaimScanPreview";

const previewTab = [{ text: "General" }];

/* Declaring Interfaces for getting inputs other tabs */
interface IPreviewTab {
  previewData: any[];
}

const SettingsTabPreview: FC<IPreviewTab> = ({ previewData }) => {
  const dispatch = useDispatch();

  const [mobileInfo, setMobileInfo] = useState<any>(previewData[0]);

  const tabName = previewData[0]?.tabApiName;

  useEffect(() => {
    // Write for onload
  });

  const msgFieldFocusOut = (event: any, key: any) => {
    setMobileInfo({ ...mobileInfo, [key]: event.target.value });
  };

  const languageData = useSelector(
    (state: RootState) => state.settingsReducer.languagesList
  );

  const msgTextFieldFocusOut = (value: any, key: any) => {
    console.log(value.target.value);
    setMobileInfo({ ...mobileInfo, [key]: value.target.value });
  };

  /**
   * Changing status for Preview selected tabs
   * @param flag - true/false
   */
  const changeStatusForRowData = (flag: any) => {
    if (tabName === "Mobile" || tabName === "Reclaim Scan") {
      if (flag === false) {
        setMobileInfo({ ...mobileInfo, activeForGrid: "Inactive" });
      } else {
        setMobileInfo({ ...mobileInfo, activeForGrid: "Active" });
      }
    }
  };

  const clearPreview = () => {
    dispatch(setRowData([]));
  };
  const footerPreview = (data: any) => {
    return (
      <div className="col-sm-12 px-0 pt-5 ">
        <div className="col-sm-6 col-md-6 col-lg-5 preview-Key  ">
          <ButtonComponent
            cssClass="e-outline opt-btn-light float-left"
            onClick={() => updateMsgMngmtSettingsTabApi(data)}
          >
            <img src={saveIcon} alt="Save" />
          </ButtonComponent>

          <ButtonComponent
            cssClass="e-outline opt-btn-light float-left ml-3"
            onClick={() => clearPreview()}
          >
            <img src={closeIcon} alt="Close" />
          </ButtonComponent>
        </div>
        <div className="col-sm-6 col-md-6 col-lg-7 preview-value pt-3">
          <p className="preview-status">
            {data.activeForGrid === "Active" ||
            data.activeForGrid === "active" ? (
              <span>
                <img
                  src={activeIcon}
                  alt="Status"
                  onClick={() => changeStatusForRowData(false)}
                />
                &nbsp; &nbsp; Active
              </span>
            ) : (
              <span>
                <img
                  src={inactiveIcon}
                  alt="Status"
                  onClick={() => changeStatusForRowData(true)}
                />
                &nbsp; &nbsp; Inactive
              </span>
            )}
          </p>
        </div>
      </div>
    );
  };

  function MsgPreview() {
    return (
      <div className="col-sm-12 px-5 py-4 preview-details  ">
        <div className="col-sm-12 px-0 pt-4 ">
          <div className="col-sm-6 col-md-6 col-lg-5 preview-Key  ">
            Message ID
          </div>
          <div className="col-sm-6 col-md-6 col-lg-7 preview-value ">
            {mobileInfo.id}
          </div>
        </div>
        <div className="col-sm-12 px-0 pt-4">
          <div className="col-sm-6 col-md-6 col-lg-5 preview-Key  ">
            Message Type
          </div>
          <div className="col-sm-6 col-md-6 col-lg-7 preview-value ">
            <select
              className="form-control border-none storeNumber"
              value={mobileInfo?.type}
              onChange={(e) => msgFieldFocusOut(e, "type")}
            >
              {/* <option value={mobileInfo?.type}>{mobileInfo?.type}</option> */}
              {mobileInfo?.type === "Success" ? (
                <>
                  <option value="Information">Information</option>
                  <option value="Warning">Warning</option>
                  <option value="Error">Error</option>
                </>
              ) : (
                ""
              )}
            </select>
          </div>
        </div>
        <div className="col-sm-12 px-0 pt-4">
          <div className="col-sm-6 col-md-6 col-lg-5 preview-Key  ">
            Language
          </div>
          <div className="col-sm-6 col-md-6 col-lg-7 preview-value ">
            <select
              className="form-control border-none storeNumber"
              value={mobileInfo?.languageKey}
              onChange={(e) => msgFieldFocusOut(e, "languageKey")}
            >
              {/* <option value={mobileInfo?.languageKey}>{mobileInfo?.languageKey}</option> */}
              {languageData?.map((ld) => (
                <option value={ld?.isoLongCode}>{ld?.isoLongCode}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="col-sm-12 px-0  mb-auto">
          <hr className="divider" />
        </div>

        <div className="col-sm-12 px-0">
          <div className="col-sm-6 col-md-6 col-lg-5 preview-Key  ">
            Msg Text
          </div>
          <div className="col-sm-6 col-md-6 col-lg-7 preview-value ">
            <input
              type="text"
              name="textarea1"
              className="form-control boxShadow-None border-none cursor-pointer pl-0 txtEditFieldFocus"
              onChange={(e: any) => msgTextFieldFocusOut(e, "text")}
              value={mobileInfo.text}
            />
            {/* <EditTextarea
                            name='textarea1'
                            rows={4}
                            className="notes-preview"
                            value={mobileInfo.text}
                            onChange={(e) => msgTextFieldFocusOut(e, 'text')}
                        /> */}
          </div>
        </div>

        <div className="col-sm-12 px-0 pt-5 pb-4">
          {footerPreview(mobileInfo)}
        </div>
      </div>
    );
  }

  const getSettingsMsgMgmtTabs = async (tabName: any) => {
    const endPointURL = messageManagemetnSettingsEndPoint(tabName);
    await axios
      .get(endPointURL)
      .then((res) => {
        if (tabName === "Reclaim Scan") {
          dispatch(setReclaimScanMsgData(res.data));
        } else if (tabName === "Mobile") {
          dispatch(setMobileMsgData(res.data));
        }
      })
      .catch((err) => {
        notify("Failed to update data", "error");
      });
  };

  const updateMsgMngmtSettingsTabApi = async (data: any) => {
    console.log(data);
    const endPointURL = updatemessageManagementSettingsEndPoint(
      tabName,
      data.id
    );
    let body = {};
    if (tabName === "Mobile" || tabName === "Reclaim Scan") {
      body = {
        id: data.id,
        messageType: data.type,
        languageKey: data.languageKey,
        messageText: data.text,
      };
    }
    const status = data.activeForGrid.toLowerCase();
    if (status === "active") {
      Object.assign(body, { active: true });
    } else {
      Object.assign(body, { active: false });
    }
    await axios
      .put(endPointURL, body)
      .then((res) => {
        notify(tabName + " Updated Successfully", "success");
        getSettingsMsgMgmtTabs(tabName);
      })
      .catch((err) => {
        notify("Failed to update data", "error");
      });
  };

  return (
    <div>
      <div className="col-sm-12 p-0 preview-card ">
        {tabName && (tabName === "Mobile" || tabName === "Reclaim Scan") ? (
          <div className="col-sm-12 col-md-12 col-lg-12 px-0">
            <div className="col-sm-12 col-md-12 col-lg-12 px-3 py-3">
              <div className="col-sm-6 col-md-5 col-lg-4 pl-4 pr-4">
                <p className="header-logo">
                  {previewData[0]?.type.substring(0, 2).toUpperCase()}
                </p>
              </div>
              <div className="col-sm-6 col-md-7 col-lg-8 pt-4 ">
                <div className="col-sm-12 p-0 main-header-text">
                  {previewData[0]?.type} Msg
                </div>
                <div className="col-sm-12 p-0 sub-header-text">
                  {previewData[0]?.id}
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-12 px-0">
              <TabComponent
                heightAdjustMode="Auto"
                cssClass="orientation-tab preview-custom-tab"
              >
                <TabItemsDirective>
                  <TabItemDirective
                    header={previewTab[0]}
                    content={PreviewReclaimScan}
                  />
                </TabItemsDirective>
              </TabComponent>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default SettingsTabPreview;
